(function () {
  if (window.__pcSwatchSwapInit) return;
  window.__pcSwatchSwapInit = true;

  function findCardImage(swatchEl) {
    var card = swatchEl.closest('.product-card');
    if (!card) return null;
    return card.querySelector('.product-card__image--main img');
  }

  function onSwatchEnter(swatch) {
    var img = findCardImage(swatch);
    if (!img) return;
    if (!img.dataset.pcOriginalSrc) {
      img.dataset.pcOriginalSrc = img.getAttribute('src') || '';
      img.dataset.pcOriginalSrcset = img.getAttribute('srcset') || '';
    }
    var src = swatch.getAttribute('data-swatch-image');
    if (!src) return;
    img.removeAttribute('srcset');
    img.setAttribute('src', src);
  }

  function onSwatchLeave(swatch) {
    var img = findCardImage(swatch);
    if (!img) return;
    var original = img.dataset.pcOriginalSrc;
    var originalSrcset = img.dataset.pcOriginalSrcset;
    if (!original) return;
    if (originalSrcset) img.setAttribute('srcset', originalSrcset);
    img.setAttribute('src', original);
  }

  function onSwatchClick(swatch) {
    var card = swatch.closest('.product-card');
    if (!card) return;
    // Find the ATC element in this card (popup trigger or default-variant ATC form button)
    var atc = card.querySelector('.product-card__atc-link[data-product-choose-options]')
           || card.querySelector('.product-card__atc-link');
    if (!atc || typeof atc.click !== 'function') return;
    // Pass the clicked swatch's variant id through to the choose-options handler so
    // the modal opens with that variant pre-selected. The handler consumes and
    // removes this attribute after use, so direct ATC clicks aren't affected.
    var variantId = swatch.getAttribute('data-variant-id');
    if (variantId) {
      atc.setAttribute('data-preselect-variant-id', variantId);
    }
    atc.click();
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card__hover-swatch');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    onSwatchClick(swatch);
  });

  document.addEventListener('mouseover', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card__hover-swatch');
    if (swatch) onSwatchEnter(swatch);
  });
  document.addEventListener('mouseout', function (e) {
    var swatch = e.target.closest && e.target.closest('.product-card__hover-swatch');
    if (!swatch) return;
    var related = e.relatedTarget;
    if (related && related.closest && related.closest('.product-card__hover-swatch') === swatch) return;
    onSwatchLeave(swatch);
  });

  // Also restore when mouse leaves the entire card
  document.addEventListener('mouseleave', function (e) {
    var card = e.target.closest && e.target.closest('.product-card');
    if (!card) return;
    var img = card.querySelector('.product-card__image--main img');
    if (img && img.dataset.pcOriginalSrc) {
      if (img.dataset.pcOriginalSrcset) img.setAttribute('srcset', img.dataset.pcOriginalSrcset);
      img.setAttribute('src', img.dataset.pcOriginalSrc);
    }
  }, true);
})();
